var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoConstructInfoHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 9C17.8 4.13989 13.8601 0.200001 9 0.200001C4.13989 0.200001 0.2 4.13989 0.2 9C0.2 13.8601 4.13989 17.8 9 17.8C13.8601 17.8 17.8 13.8601 17.8 9Z",
    stroke: "#CCCCCC",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.20711L6.73162 10.8536C6.56425 11.0488 6.29289 11.0488 6.12553 10.8536C5.95816 10.6583 5.95816 10.3417 6.12553 10.1464L8.69695 7.14645C8.86432 6.95118 9.13568 6.95118 9.30305 7.14645L11.8745 10.1464C12.0418 10.3417 12.0418 10.6583 11.8745 10.8536C11.7071 11.0488 11.4358 11.0488 11.2684 10.8536L9 8.20711Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_1671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 6,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.20711L6.73162 10.8536C6.56425 11.0488 6.29289 11.0488 6.12553 10.8536C5.95816 10.6583 5.95816 10.3417 6.12553 10.1464L8.69695 7.14645C8.86432 6.95118 9.13568 6.95118 9.30305 7.14645L11.8745 10.1464C12.0418 10.3417 12.0418 10.6583 11.8745 10.8536C11.7071 11.0488 11.4358 11.0488 11.2684 10.8536L9 8.20711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_1671)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConstructInfoHide);
export default __webpack_public_path__ + "static/media/ico-construct-info-hide.68cde2b56dd756703bd15c7303a9f013.svg";
export { ForwardRef as ReactComponent };